<template>
  <div class="api-layer">
    <fieldset>
      <legend>RoomCall</legend>

      <div class="api-box inline"
           :class="{inline: !callInfo.desc}"
      >
        <label class="api-title">info</label>
        roomId:<input type="text" name="roomId" />
        <button @click="getRoomCallInfo">OK</button>
        <div
            v-if="!!callInfo.desc"
        >
          <pre>{{ callInfo.desc }}</pre>
        </div>
      </div>

      <div class="api-box">
        <label class="api-title">change callType</label>
        roomId:<input type="text" name="roomId" />
        &nbsp;
        <select name="callType">
          <option
              v-for="callType in ['p2p', 'mixing', 'mixer-sfu']"
              :key="callType"
              :value="callType"
          >{{callType}}</option>
        </select>
        <button @click="changeCallType">OK</button>
      </div>

    </fieldset>
  </div>
</template>

import {SysAdmin} from "@/core/sysadmin/sysadmin.api";

<script>
import {SysAdmin} from "@/core/sysadmin/sysadmin.api";
import SysAdminBase from "@/components/Sysadmin/SysAdminBase";

export default {
  name: "RoomCall",
  mixins: [SysAdminBase],
  data() {
    return {
      callInfo: {
        desc: null
      },
    }
  },

  methods: {
    ...(() => {
      const methods = {
        async getRoomCallInfo(e) {
          const roomId = this.getRoomIdValue(e);
          if(!roomId) return;

          const data = await SysAdmin.get({url: '/room/call/info', params: {
              roomId
          }})
          console.log(data);

          this.callInfo.desc = data;
        },
        changeCallType(e) {
          const roomId = this.getRoomIdValue(e);
          if(!roomId) return;

          const callType = this.getFieldValue(e, '[name="callType"]')
          if(!callType) return;

          if(!confirm('go?')) return;

          SysAdmin.post({url: '/room/call/changeCallType', params: {
              roomId, callType
            }})
        }
      }

      return SysAdmin.createDebounceMethods(methods);
    })(),
  },
}
</script>

<style lang="scss" scoped>

</style>